/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：513
 */

module.exports = {
  hide: "style_hide__EDL81",
  "coco-widget-wrapper": "style_coco-widget-wrapper__3jL6Q",
  "coco-child-widget": "style_coco-child-widget__17YQW",
  "coco-child-widget-selected": "style_coco-child-widget-selected__1POQi",
  "coco-child-widget-full": "style_coco-child-widget-full__2-84w",
  imageWidget: "style_imageWidget__y1BJc"
}
